import type { Filter } from "@/Pages/Cases/filtering/filters/CaseFilter";
import { deepClone } from "@/App/utils/deepClone";
import type { CaseFilterGroup } from "@/Pages/Cases/filtering/CaseFilterGroup";

export const isFilterEnabled = ({ filters, filterToCheck }: { filters: Filter[]; filterToCheck: Filter }): boolean => {
  return filters.some((filter) => isEqual(filterToCheck, filter));
};

export const isFilterOfGroupEnabled = ({ filters, group }: { filters: Filter[]; group: CaseFilterGroup }): boolean => {
  return filters.some((filter) => filter.group === group);
};

export const removeFilterGroup = ({ filters, group }: { filters: Filter[]; group: CaseFilterGroup }): Filter[] => {
  return filters.filter((filter) => filter.group !== group);
};

const isEqual = (a: Filter, b: Filter): boolean => JSON.stringify(a) === JSON.stringify(b);

export const removeFilter = ({ filters, filterToRemove }: { filters: Filter[]; filterToRemove: Filter }): Filter[] => {
  return filters.filter((filter) => !isEqual(filter, filterToRemove));
};

export const addFilter = ({
  filters,
  filterToAdd,
  excludeFromSameGroup = true,
}: {
  filters: Filter[];
  filterToAdd: Filter;
  excludeFromSameGroup?: boolean;
}): Filter[] => {
  let result = deepClone(filters);
  if (excludeFromSameGroup && filterToAdd.group) {
    result = filters.filter((filter) => filterToAdd.group !== filter.group);
  }
  result.push(filterToAdd);
  return result;
};

export const addFilters = ({
  filters,
  filtersToAdd,
  excludeFromSameGroup = true,
}: {
  filters: Filter[];
  filtersToAdd: Filter[];
  excludeFromSameGroup?: boolean;
}): Filter[] => {
  let result = deepClone(filters);
  if (excludeFromSameGroup) {
    const groups = filters.map((filter) => filter?.group).filter((filter) => filter);
    result = filters.filter((filter) => !groups.includes(filter.group));
  }
  result.push(...filtersToAdd);
  return result;
};
